module.exports = __webpack_public_path__ + "img/Floete.7eb5b0bc.png";